import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Card,
  Space,
  Typography,
  Breadcrumb,
  Row,
  Col,
  Switch,
  Popover,
} from "antd";
import {
  DeleteOutlined,
  HomeOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { Spinner } from "reactstrap";
import DataTable from "../../components/CustomDatatable/index.js";
import moment from "moment";
import { stringSorter } from "../../utils/functions.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllEwayTransaction,
  deleteEwayTransaction,
  updateEwayTransaction,
  addEwayTransaction,
} from "../../store/actions/ewayTransaction.js";
import Swal from "sweetalert2";
import EwayTransactionForm from "./EwayTransactionForm.js";
import { getCustomers } from "../../store/actions/customers";
import { getPackage } from "../../store/actions/package";
import { getPackageTransaction } from "../../store/actions/packageTransactions.js";

const { Title } = Typography;

const typeOptions = [
  { id: "EWAY", name: "EWAY" },
  { id: "EINVOICE", name: "EINVOICE" },
];

const EwayTransaction = () => {
  document.title = "Eway Transaction";
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const dispatch = useDispatch();
  const ewayTransaction = useSelector((state) => state?.ewayTransaction?.list);
  const customers = useSelector((state) => state.customers.list);
  const packageTransaction = useSelector(
    (state) => state.packageTransaction.list
  );


  const getData = useCallback(async () => {
    setIsLoading(true);
    await dispatch(getAllEwayTransaction());
    setIsLoading(false);
  }, [dispatch]);

  const handleCreate = useCallback(
    async (values) => {
      if (selectedRecord?.id) {
        const updateData = {
          id: selectedRecord?.id,
          ...values,
        };
        await dispatch(updateEwayTransaction(updateData));
      } else {
        await dispatch(addEwayTransaction(values));
      }
    },
    [dispatch, selectedRecord?.id]
  );

  const renderCell = (text) => (text ? text : "N/A");

  const content = (
    <div>
      <p>
        This record is linked with the package transaction, you can make your
        edits from that transaction.
      </p>
    </div>
  );
  let columns = [
    {
      title: "Customer Name",
      dataIndex: "customername",
      key: "customername",
      sorter: stringSorter("customername"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Package Name",
      dataIndex: "packageName",
      key: "packageName",
      sorter: stringSorter("packageName"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      sorter: stringSorter("type"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Qty",
      dataIndex: "count",
      key: "count",
      sorter: stringSorter("count"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Rate Par Pcs",
      dataIndex: "ratePerPcs",
      key: "ratePerPcs",
      sorter: stringSorter("ratePerPcs"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Amount",
      dataIndex: "amt",
      key: "amt",
      sorter: stringSorter("amt"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Order Id",
      dataIndex: "pgOrderId",
      key: "pgOrderId",
      sorter: stringSorter("pgOrderId"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Payment Id",
      dataIndex: "pgPaymentId",
      key: "pgPaymentId",
      sorter: stringSorter("pgPaymentId"),
      sortDirections: ["ascend", "descend"],
    },

    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "",
      sorter: (a, b) =>
        moment(a.createdAt).isValid() && moment(b.createdAt).isValid()
          ? moment(a.createdAt).unix() - moment(b.createdAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Created By",
      dataIndex: "createdByName",
      key: "createdByName",
      sorter: stringSorter("createdByName"),
      sortDirections: ["ascend", "descend"],
      render: renderCell,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date) =>
        moment(date).isValid() ? moment(date).format("DD/MM/YYYY") : "",
      sorter: (a, b) =>
        moment(a.updatedAt).isValid() && moment(b.updatedAt).isValid()
          ? moment(a.updatedAt).unix() - moment(b.updatedAt).unix()
          : 0,
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Updated By",
      dataIndex: "updatedByName",
      key: "updatedByName",
      sorter: stringSorter("updatedByName"),
      sortDirections: ["ascend", "descend"],
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <Switch
          checked={text === 1}
        //   onChange={() => handleChangeStatus(record.id, text)}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Popover content={content} title="Info" trigger="hover">
            <Button type="link">
              <InfoCircleOutlined />
            </Button>
          </Popover>
          {/* <Button
            type="link"
            onClick={() => {
              setSelectedRecord(record);
              setIsModalVisible(true);
            }}
          >
            <EditOutlined />
          </Button> */}
          <Button
            danger
            icon={<DeleteOutlined />}
            //   onClick={() => handleDelete(record)}
            onClick={() => {
              Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
              }).then((result) => {
                if (result.isConfirmed) {
                  dispatch(deleteEwayTransaction(record.id));
                }
              });
            }}
          >
            {/* Delete */}
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getPackage());
    dispatch(getPackageTransaction());
  }, [dispatch]);

  return (
    <div className="page-content">
      <Breadcrumb style={{ marginBottom: "16px" }}>
        <Breadcrumb.Item href="/">
          <HomeOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Eway Transaction</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Space direction="vertical" size="middle" style={{ width: "100%" }}>
          <Row justify="space-between" align="middle">
            <Col>
              <Title level={2} style={{ margin: 0 }}>
                Eway Transaction
              </Title>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  setSelectedRecord(null);
                  setIsModalVisible(true);
                }}
              >
                Add Eway Transaction
              </Button>
            </Col>
          </Row>
          {isLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <DataTable
              dataSource={ewayTransaction?.map((item) => ({
                ...item,
                key: item?.id,
                status: item?.status,
              }))}
              columns={columns}
              filterBy={[
                {
                  field: "cusId",
                  fieldType: "SELECT",
                  options: customers,
                  filter: "id",
                  label: "customer",
                },
                {
                  field: "ptId",
                  fieldType: "SELECT",
                  options: packageTransaction.map((pt) => ({
                    ...pt,
                    name: pt.packageName,
                  })),
                  filter: "id",
                  label: "packages transaction",
                },
                {
                  field: "type",
                  fieldType: "SELECT",
                  options: typeOptions,
                  filter: "id",
                  label: "type",
                },
              ]}
              isActive={false}
            />
          )}
        </Space>
      </Card>
      <EwayTransactionForm
        visible={isModalVisible}
        onCreate={handleCreate}
        onCancel={() => setIsModalVisible(false)}
        record={selectedRecord}
      />
    </div>
  );
};

export default EwayTransaction;
